import { OnlineApplications } from "./OnlineApplications"

export const OnlineApplicationsRoute = () => <OnlineApplications />